<template>
  <div
    class="structure-container"
    :class="{
      'sidebar-closed': !isSidebarVisible,
      'mini': isMiniSidebar
    }"
  >
    <intl-navbar
      :is-sidebar-visible="isSidebarVisible"
      :is-mini-sidebar="isMiniSidebar"
      @toggleSidebar="handleSidebarVisibilityChange"
    />
    <intl-sidebar @toggleSidebar="handleSidebarVisibilityChange">
      <sidebar-content />
      <div
        class="sidebar-size-toggle"
        @click="handleSidebarSizeChange"
      >
        <font-awesome-icon
          icon="chevron-left"
        />
      </div>
    </intl-sidebar>

    <main-section>
      <div v-if="getWindowWidth() > 400">
        <transition
          name="page-change"
          mode="out-in"
        >
          <router-view />
        </transition>
      </div>
      <div v-else>
        <router-view />
      </div>
      <intl-footer>
        <footer-content />
      </intl-footer>
    </main-section>
  </div>
</template>

<script>
import IntlNavbar from './IntlNavbar'
import IntlSidebar from './IntlSidebar'
import SidebarContent from '../components/SidebarContent'
import FooterContent from '../components/FooterContent'
import MainSection from './MainSection'
import IntlFooter from './IntlFooter'

export default {

  name: 'Structure',
  components: {
    IntlNavbar,
    IntlSidebar,
    IntlFooter,
    SidebarContent,
    FooterContent,
    MainSection
  },

  data () {
    return {
      isMiniSidebar: false,
      isSidebarVisible: true
    }
  },

  methods: {
    handleSidebarSizeChange () {
      this.isMiniSidebar = !this.isMiniSidebar
    },
    handleSidebarVisibilityChange () {
      this.isSidebarVisible = !this.isSidebarVisible
    },
    getWindowWidth () {
      return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/_variables.scss';

.structure-container {
  overflow: hidden;
}

@media only screen and (max-width: $break-small) {
  .sidebar-size-toggle {
    display: none;
  }
}

</style>
